const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

const trimTrailingSlash = (value) => String(value || "").replace(/\/+$/, "");

export const getRealtimeSocketBaseUrl = () =>
  trimTrailingSlash(process.env.REACT_APP_SOCKET_URL || "");

export const getRealtimeSocketToken = async () => {
  const base = trimTrailingSlash(BACKEND);
  if (!base) return null;

  const response = await fetch(`${base}/api/auth/ws-token`, {
    method: "GET",
    credentials: "include",
  });

  const data = await response.json().catch(() => null);
  if (!response.ok || !data?.serverToken) {
    throw new Error(data?.error || "Unable to fetch websocket token.");
  }

  return String(data.serverToken);
};

export const buildRealtimeSocketUrl = (baseUrl, accessToken) => {
  const normalizedBase = trimTrailingSlash(baseUrl);
  if (!normalizedBase) return "";

  const wsUrl = /\/transcribe$/i.test(normalizedBase)
    ? normalizedBase
    : `${normalizedBase}/transcribe`;
  if (!accessToken) return wsUrl;

  const url = new URL(wsUrl);
  url.searchParams.set("access_token", accessToken);
  return url.toString();
};
